module.exports = __webpack_public_path__ + "foto-sala.jpg?4422274aa6f03abbf2698e68b536cc78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foto-sala.jpg
// module id = 94
// module chunks = 0